<template>
  <div class="drug-info contant-wrap">
    <div class="filter-data">
      <h3>库存预警</h3>
      <div class="filter-control">
        <el-row>
          <el-col :span="6">
            <div class="rows">
              <label for="">药品分类：</label>
              <el-select v-model="query.drugType" placeholder="请选择" @change="getTableData(1)">
                <el-option
                  v-for="item in drugType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-table :data="stockList" :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}" style="width: 100%" class="table">
      <el-table-column prop="drugName" label="药品名称">
        <template slot-scope="scope">
          <img src="../../../assets/images/logo-l.png" class="logo-img"  v-if="scope.row.isShopDrugs === 1"/>
          {{scope.row.drugName}}
        </template>
      </el-table-column>
      <el-table-column prop="drugType" label="药品分类">
        <template slot-scope="scope">
          {{scope.row.drugType | setDrugType}}
        </template>
      </el-table-column>
      <el-table-column prop="specification" label="规格">
      </el-table-column>
      <el-table-column prop="manufacturer" label="厂家" min-width="150">
      </el-table-column>
      <el-table-column prop="inventoryCount" label="总库存">
      </el-table-column>
      <el-table-column prop="inventoryThreshold" label="库存阈值">
        <template slot-scope="scope">
          {{scope.row.inventoryThreshold}}{{scope.row.inventoryThresholdUnit}}
        </template>
      </el-table-column>
      <el-table-column prop="option" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="toFlow(scope.row.drugId)">查看流向</el-button>
          <el-button type="text" @click="showDetail(scope.row.drugName, scope.row.drugId)">批号详情</el-button>
          <el-button type="text" @click="toEdit(scope.row.drugId)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="stockList.length > 0">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync = "currentPage4"  :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- dialog -->
    <el-dialog :title="tableTitle" :visible.sync="dialogTableVisible" width="760px">
      <el-table :data="tableData" height="300px">
        <el-table-column property="drugBatchNo" align="left" label="批号" width="150"></el-table-column>
        <el-table-column property="specification" align="center" label="规格" width="200"></el-table-column>
        <el-table-column property="validityDate" align="center" label="有效期"></el-table-column>
        <el-table-column property="purchasePrice" align="center" label="进货价"></el-table-column>
        <el-table-column property="stock" align="center" label="当前数量"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { pageSizes, drugType } from '@/config/constant';

export default {
  name: 'home',
  data() {
    return {
      pageSizes,
      drugType,
      stockList: [], // 库存列表
      tableData: [], // 批次详情列表
      total: 100, // 总数据条数
      pageSize: 20, // 每页数据条数
      currentPage4: 1, // 页码 从1开始
      dialogTableVisible: false, // 批次详情弹框
      tableTitle: '批号详情', // 批次详情弹框标题
      query: {
        drugType: -1, // 药品类型
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 获取库存列表信息
    getTableData(type) {
      if(type === 1){
        this.currentPage4 = 1;
      }
      this.$api.drugControl.inventoryWarnings({
        ...this.query,
        currentPage: this.currentPage4,
        pageSize: this.pageSize
      }).then(res => {
        console.log(res);
        this.stockList = res.warningDrugs;
        this.total = res.totalSize;
      })
    },
    // 显示批次详情
    showDetail(drugName, drugId) {
      this.$api.drugControl.batchInstockDetail({
        drugId: drugId
      }).then(res => {
        this.tableData = res;
        this.dialogTableVisible = true; // 显示弹框
        this.tableTitle = `"${drugName}"批号详情`;
      })
      
    },
    // 查看流向
    toFlow(id) {
      this.$router.push({name: 'flowQuery', query: {drugId: id}})
    },
    // 编辑药品
    toEdit(drugIds) {
      this.$router.push({ name: 'drugDetail', query: { state: 'edit', drugId: drugIds } });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(value) {
      this.currentPage4 = value;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
